import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "region-dashboards-dynamic-cards"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DateActualDataSubtitle = _resolveComponent("DateActualDataSubtitle")!
  const _component_RegionDashboardsDynamicCard = _resolveComponent("RegionDashboardsDynamicCard")!
  const _component_DashboardsCardsWrapper = _resolveComponent("DashboardsCardsWrapper")!

  return (_ctx.dynamicCards.length)
    ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
        _cache[0] || (_cache[0] = _createElementVNode("h2", { class: "title title--regions-economic cursor-pointer" }, "Динамика ключевых показателей по субъекту РФ", -1)),
        _createVNode(_component_DateActualDataSubtitle, {
          class: "region-dashboards-dynamic-cards__subtitle",
          filter: _ctx.filter
        }, null, 8, ["filter"]),
        _createVNode(_component_DashboardsCardsWrapper, {
          items: _ctx.dynamicCards,
          itemKey: "title"
        }, {
          default: _withCtx(({ item }) => [
            _createVNode(_component_RegionDashboardsDynamicCard, {
              card: item,
              year: _ctx.filter.year,
              isLoading: _ctx.isLoading
            }, null, 8, ["card", "year", "isLoading"])
          ]),
          _: 1
        }, 8, ["items"])
      ]))
    : _createCommentVNode("", true)
}